import { useCurrentBox } from "@modules/box/useBox"
import { BoxOfferType, LightBoxOfferInfo } from "@modules/boxOffer/entities/boxOfferTypes"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { formatCurrency } from "@modules/currency/currency"
import { useLanguage } from "@modules/language/hooks/useLanguage"
import { getFormattedReductedProgramPrice } from "@modules/promoCode/utils/promoCodeUtils"
import { HUText } from "@modules/ui/components/huText"
import { HURow, HUStack } from "@modules/ui/components/layout"

export const BoxOfferReductionItem: React.FC<{
  boxOffer: LightBoxOfferInfo
  promoCodeValue?: number
  promoCodeType?: CouponType
  promoCodeDuration?: number
}> = ({ boxOffer, promoCodeValue, promoCodeType, promoCodeDuration }) => {
  const language = useLanguage()
  const { result: box } = useCurrentBox()

  return (
    <HURow gap={10}>
      <HUStack gap={2}>
        <HUText fontStyle="LL">{boxOffer.name}</HUText>
        <HUText fontStyle="BS">
          {`${formatCurrency(boxOffer.price.value || 0, boxOffer.price.currency || box?.stripeAccountCurrency, language)} ${boxOffer.type === BoxOfferType.Subscription ? word("program.price.priceSlashPerMonth") : ""}`}
          <span className={`pi pi-arrow-right text-xs px-2`} />
          {`${getFormattedReductedProgramPrice(language, boxOffer.price, promoCodeValue, promoCodeType, box?.stripeAccountCurrency)} ${boxOffer.type === BoxOfferType.Subscription ? word("program.price.priceSlashPerMonth") : ""} ${!!promoCodeDuration ? word("promoCode.duringXMonths", { count: promoCodeDuration }) : ""}`}
        </HUText>
      </HUStack>
    </HURow>
  )
}
